import Entity from "./entity";
import ActionCheckpoint from "./entity";

export default class ActionTracking extends Entity<string> {
  name: string;
  trackingTargetMetricType: number;
  measurementUnit: number;
  trackingTarget: number;
  trackingQuestionType: number;
  trackingQuestion: string;
  cronExpression: string;
  checkpoints: [ActionCheckpoint<string>];
}
